// Название и подпись платформы. Можно переопределить при сборке:
// REACT_APP_BRAND_NAME="..." REACT_APP_BRAND_TAGLINE="..." npm run build
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'Кадрум';
export const BRAND_TAGLINE = process.env.REACT_APP_BRAND_TAGLINE || 'Видеохостинг';
